import React from 'react';
import GameModeMenu from '../components/GameModeMenu';
import SideMenu from '../components/SideMenu';
import { Outlet } from 'react-router-dom';

export default function Insights() {
    const tabContentFn = (gameMode, rankingType) => {
        return <Outlet context={[gameMode, rankingType]} />;
    }
    return (
        <div className='flex'>
            <SideMenu />
            <GameModeMenu tabContentFn={tabContentFn}></GameModeMenu>
        </div>
    );
};